import React from 'react'
import './Spinner.css'
const Spinner = () => {
  return (
    <div>
<div>
<div class="loader"></div>
</div>
    </div>
  )
}

export default Spinner
